/* eslint-disable react-hooks/set-state-in-effect, react-hooks/exhaustive-deps, @typescript-eslint/no-unused-vars */
import TextField, { TextFieldProps } from "@mui/material/TextField";
import { DefaultCreditCardDelimiter, formatNumeral, registerCursorTracker } from "cleave-zen";
import React, { useEffect, useRef, useState } from "react";

export type CurrentTextFieldProps = TextFieldProps & {
  decimalPoints?: number;
};

const formatValue = (text?: string, decimalPoints?: number) => {
  return formatNumeral(text ?? "", {
    numeralDecimalScale: decimalPoints ?? 2,
    prefix: "$",
  });
};

export function CurrencyTextField(props: CurrentTextFieldProps) {
  const [value, setValue] = useState(formatValue(props.value as string, props.decimalPoints));
  const inputRef = useRef(null);

  useEffect(() => {
    const newValue = formatValue(props.value as string, props.decimalPoints);
    if (value !== newValue) {
      setValue(newValue);
    }
  }, [props.value, props.decimalPoints, value]);

  useEffect(() => {
    if (inputRef.current) {
      return registerCursorTracker({ input: inputRef.current, delimiter: DefaultCreditCardDelimiter });
    }
  }, [inputRef]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(formatValue(event.target.value, props.decimalPoints));
    props.onChange?.(event);
  };

  const { decimalPoints: _decimalPoints, ...textFieldProps } = props;

  return <TextField {...textFieldProps} ref={inputRef} value={value} onChange={handleChange} />;
}
